'use client';

import { useEffect, useMemo, useState } from 'react';

export function shuffleCopy<T>(items: T[]): T[] {
  const next = [...items];
  for (let i = next.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
}

function buildShuffleSignature(items: any[]): string {
  return items
    .map((item, index) => {
      if (item && typeof item === 'object') {
        return item.id || item.label || item.content || item.title || String(index);
      }
      return String(item);
    })
    .join('|');
}

export function useMountShuffledList<T>(items: T[], enabled: boolean = true): T[] {
  const signature = useMemo(() => buildShuffleSignature(items as any[]), [items]);
  const [shuffled, setShuffled] = useState<T[]>(() => (enabled ? items : items));

  useEffect(() => {
    setShuffled(enabled ? shuffleCopy(items) : [...items]);
  }, [enabled, signature]);

  return enabled ? shuffled : items;
}
